import React, { useState, useEffect } from "react";

import { Route, Switch, Redirect } from "react-router-dom";

import NotFound from "./NotFound";

import Home from "./Home";

import ProcessLogin from "./ProcessLogin";
// import PDFViewer from '../Attachments/PDFViewer';

import Reports from "../Administrator/Reports";
import Office from "../Administrator/Office";

import AccessDenied from "./AccessDenied";
import LoginForm from "./LoginForm";

import Axios from "axios";

import UserAccess from "../Administrator/UserAccess";

import NavBarPlaceholder from "./NavBarPlaceholder";

import DPC from "./DPC";

import Returns from "../modules/Returns";
import AuditTrail from "../Administrator/AuditTrail";
import UsersManagement from "../Administrator/UsersManagement";
import Receiving from "../Receiving/Receiving";
import SeedPlanting from "../SeedPlanting/SeedPlanting";
import Sales from "../Sales/Sales";

import Expenses from "../Administrator/Expenses";
import SalesMain from "../Sales/SalesMain";
import AdminHome from "./AdminHome";
import ExpensesMain from "../Expenses/ExpensesMain";
import Dealers from "../Administrator/Dealers";
import Bundles from "../Administrator/Bundles";
import Items from "../Administrator/Items";
import Suppliers from "../Administrator/Suppliers";
import CustomerTicketMain from "../Sales/CustomerTicketMain";
import POSMain from "../POS/POSMain";
import SalesBlank from "../Sales/SalesBlank";
import PriceChecker from "../Administrator/PriceChecker";
import Inventory from "../Administrator/Inventory";
import SalesMainCashier from "../Sales/SalesMainCashier";
import Services from "../Administrator/Services";
import Packages from "../Administrator/Packages";
import ServicesChecker from "./ServicesChecker";
import PackagesChecker from "./PackagesChecker";
import ItemsOutsourced from "../Administrator/ItemsOutsourced";
import ServicesOutsourced from "../Administrator/ServicesOutsourced";
import LoginFormGoogle from "./LoginFormGoogle";
import CustomerHome from "./CustomerHome";

function AzureAuthenticatedRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        sessionStorage.getItem("msal.uc") === null ? (
          <Redirect
            to={{
              // pathname:'LoginMain' ,
              pathname: "LoginPage",
              state: { from: props.location },
            }}
          />
        ) : rest.isAuthorizedUser === 1 ? (
          <React.Fragment>
            <NavBarPlaceholder
              deployURL={rest.deployURL}
              apiServer={rest.apiServer}
              apiServerHybrid={rest.apiServerHybrid}
              pageTitle={rest.pageTitle}
              setPageTitle={rest.setPageTitle}
            />

            <Component {...rest} />
          </React.Fragment>
        ) : (
          <NotFound />
        )
      }
    />
  );
}

const Routes = (props) => {
  const bearer = {
    headers: {
      Authorization: "Bearer " + sessionStorage.getItem("hash"),
    },
  };

  const [isAuthorizedUser, setAuthorizedUser] = useState(0);

  function checkAccess() {
    if (sessionStorage.getItem("msal.uc") === null) {
      setAuthorizedUser(0);
      return;
    }

    Axios.get(
      props.apiServer +
        "/authorizedcustomer?username=" +
        sessionStorage.getItem("msal.uc"),
      bearer
    )
      .then((res) => {
        setAuthorizedUser(0);
        setAuthorizedUser(res.data[0].iscustomer);
        console.log(res.data[0].iscustomer);
      })

      .catch((error) => {
        console.log(error);
      });
  }

  const useMountEffect = (functionName) => useEffect(functionName, []);

  useMountEffect(checkAccess);

  return (
    <React.Fragment>
      <Switch>
        <Route
          exact
          strict
          path={process.env.PUBLIC_URL + "/pdfviewer"}
          render={(routeProps) => (
            <PDFViewer
              {...routeProps}
              deployURL={props.deployURL}
              apiServer={props.apiServer}
            />
          )}
        />

        <Route
          exact
          strict
          path={process.env.PUBLIC_URL + "/dataprivacy"}
          render={(routeProps) => (
            <DPC
              {...routeProps}
              deployURL={props.deployURL}
              apiServer={props.apiServer}
            />
          )}
        />

        <Route
          exact
          strict
          path={process.env.PUBLIC_URL + "/LoginPage"}
          render={(routeProps) => (
            <LoginFormGoogle
              {...routeProps}
              deployURL={props.deployURL}
              apiServer={props.apiServer}
            />
          )}
        />

        <Route
          exact
          strict
          path={process.env.PUBLIC_URL + "/ProcessLogin"}
          render={(routeProps) => (
            <ProcessLogin
              {...routeProps}
              deployURL={props.deployURL}
              apiServer={props.apiServer}
            />
          )}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/"}
          component={CustomerHome}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          apiServerPOS={props.apiServerPOS}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <CustomerHome {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/home"}
          component={CustomerHome}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          apiServerPOS={props.apiServerPOS}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <CustomerHome {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/useraccess"}
          component={UserAccess}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <UserAccess {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/receiving"}
          component={Receiving}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          strNewEmployee={sessionStorage.getItem("msal.ec")}
          employeeCodeGlobal={sessionStorage.getItem("msal.ec")}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Receiving {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/inventory"}
          component={Inventory}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          strNewEmployee={sessionStorage.getItem("msal.ec")}
          employeeCodeGlobal={sessionStorage.getItem("msal.ec")}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Inventory {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/posmain"}
          component={POSMain}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          apiServerPOS={props.apiServerPOS}
          strNewEmployee={sessionStorage.getItem("msal.ec")}
          employeeCodeGlobal={sessionStorage.getItem("msal.ec")}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <POSMain {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/cashiermain"}
          component={SalesMainCashier}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          apiServerPOS={props.apiServerPOS}
          strNewEmployee={sessionStorage.getItem("msal.ec")}
          employeeCodeGlobal={sessionStorage.getItem("msal.ec")}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <SalesMainCashier {...routeProps} />}
        />
        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/expenses"}
          component={ExpensesMain}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          strNewEmployee={sessionStorage.getItem("msal.ec")}
          employeeCodeGlobal={sessionStorage.getItem("msal.ec")}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <ExpensesMain {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/returns"}
          component={Returns}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          strNewEmployee={sessionStorage.getItem("msal.ec")}
          employeeCodeGlobal={sessionStorage.getItem("msal.ec")}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Returns {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/audittrail"}
          component={AuditTrail}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          strNewEmployee={sessionStorage.getItem("msal.ec")}
          employeeCodeGlobal={sessionStorage.getItem("msal.ec")}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <AuditTrail {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/dealers"}
          component={Dealers}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Dealers {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/customerticket"}
          component={CustomerTicketMain}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <CustomerTicketMain {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/suppliers"}
          component={Suppliers}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Suppliers {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/items"}
          component={Items}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Items {...routeProps} />}
        />
        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/itemsoutsourced"}
          component={ItemsOutsourced}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <ItemsOutsourced {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/services"}
          component={Services}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Services {...routeProps} />}
        />
        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/servicesoutsourced"}
          component={ServicesOutsourced}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <ServicesOutsourced {...routeProps} />}
        />
        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/serviceschecker"}
          component={ServicesChecker}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <ServicesChecker {...routeProps} />}
        />
        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/packageschecker"}
          component={PackagesChecker}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <PackagesChecker {...routeProps} />}
        />
        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/packages"}
          component={Packages}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Packages {...routeProps} />}
        />
        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/pricechecker"}
          component={PriceChecker}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <PriceChecker {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/bundles"}
          component={Bundles}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          strNewEmployee={sessionStorage.getItem("msal.ec")}
          employeeCodeGlobal={sessionStorage.getItem("msal.ec")}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Bundles {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/salesadmin"}
          component={SalesMain}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          strNewEmployee={sessionStorage.getItem("msal.ec")}
          employeeCodeGlobal={sessionStorage.getItem("msal.ec")}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <SalesMain {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/administrator"}
          component={AdminHome}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <AdminHome {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/usersmanagement"}
          component={UsersManagement}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <UsersManagement {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/expensestool"}
          component={Expenses}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Expenses {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/officemanagement"}
          component={Office}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Office {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/offices"}
          component={Office}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Office {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/reports"}
          component={Reports}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <Reports {...routeProps} />}
        />

        <AzureAuthenticatedRoute
          exact
          strict
          path={process.env.PUBLIC_URL + "/AccessDenied"}
          component={AccessDenied}
          deployURL={props.deployURL}
          apiServer={props.apiServer}
          apiServerHybrid={props.apiServerHybrid}
          isAuthorizedUser={isAuthorizedUser}
          render={(routeProps) => <AccessDenied {...routeProps} />}
        />

        <Route
          exact
          strict
          path="*"
          render={(routeProps) => (
            <NotFound
              {...routeProps}
              deployURL={props.deployURL}
              apiServer={props.apiServer}
            />
          )}
        />

        {/* 

            <Route 
            strict 
            path="*" 
            component={NotFound} 

            />  */}
      </Switch>
    </React.Fragment>
  );
};

export default Routes;
